const appNotificationLang = {
	x_documents: {
		tag: 'app.notification.x_documents',
		fr: '{{count}} documents',
		en: '{{count}} documents',
		plurals: {
			zero: {
				fr: 'Aucun document',
				en: 'No document',
			},
			one: {
				fr: '{{count}} document',
				en: '{{count}} document',
			},
			other: {
				fr: '{{count}} documents',
				en: '{{count}} documents',
			},
		},
	},
	x_news: {
		tag: 'app.notification.x_news',
		fr: '{{count}} news',
		en: '{{count}} news',
		plurals: {
			zero: {
				fr: 'Aucune news',
				en: 'No news',
			},
			one: {
				fr: '{{count}} news',
				en: '{{count}} news',
			},
			other: {
				fr: '{{count}} news',
				en: '{{count}} news',
			},
		},
	},
};

export default appNotificationLang;
